module.exports = __webpack_public_path__ + "static/img/logo-rappi-new.5ab6b78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimonial/logo-rappi-new.svg
// module id = +x0A
// module chunks = 0